export class TblASortData {
    id?: number;
    fieldId?: string;
    empNum?: number;
    submittedResult?: string;
    bidAwards?: any;
  }